import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=798d1127&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=798d1127&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798d1127",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798d1127')) {
      api.createRecord('798d1127', component.options)
    } else {
      api.reload('798d1127', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=798d1127&scoped=true", function () {
      api.rerender('798d1127', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/SAS/Components/Dashboard.vue"
export default component.exports